import ErrorTypes from './types';

export default class UnauthorizedError extends Error {
  constructor(message?: string, options?: ErrorOptions) {
    super(message, options);
    this.name = ErrorTypes.UNAUTHORIZED;
  }
}
